import React, { useState, useEffect } from 'react';

import { Modal } from 'antd';

import GridQueryTable from './GridQueryTable';

import GridQueryAction from './GridQueryAction';
import { useGlobalModal } from 'hooks';

const ManageQueriesModal = ({ setIsMounted }) => {
  const [selectedQuery, setSelectedQuery] = useState(null);

  const [editModalVisible, setEditModalVisible] = useState(false);

  const { MODAL_NAMES, checkModalVisible, closeModal } = useGlobalModal();
  const isVisible = checkModalVisible(MODAL_NAMES.MANAGE_QUERIES);

  useEffect(() => {
    if (isVisible) setSelectedQuery(null);
  }, [isVisible]);

  return (
    <Modal
      title='Manage Queries'
      visible={isVisible}
      onOk={() => closeModal(MODAL_NAMES.MANAGE_QUERIES)}
      onCancel={() => {
        closeModal(MODAL_NAMES.MANAGE_QUERIES);
      }}
      width='80vw'
      height='80vh'
      footer={null}
      className='manage-grid__modal'
      destroyOnClose
    >
      {isVisible ? (
        <>
          <GridQueryAction
            selectedQuery={selectedQuery}
            setSelectedQuery={setSelectedQuery}
            setEditModalVisible={setEditModalVisible}
          />
          <GridQueryTable
            turnOffModal={() => closeModal(MODAL_NAMES.MANAGE_QUERIES)}
            setIsMounted={setIsMounted}
            selectedQuery={selectedQuery}
            setSelectedQuery={setSelectedQuery}
            editModalVisible={editModalVisible}
            setEditModalVisible={setEditModalVisible}
          />
        </>
      ) : null}
    </Modal>
  );
};

export default ManageQueriesModal;
